import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserComponent } from './user.component';

import { PersonalComponent } from './personal/personal.component';
import { SecurityComponent } from './security/security.component';

const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    children: [
      { path: 'personal', component: PersonalComponent },
      { path: 'security', component: SecurityComponent },
      { path: '', redirectTo: 'personal', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
